<template>
  <SelectWithSearch
    v-model="input"
    :label="label"
    :change="change"
    :options="cfopCollection"
    :error="error"
    :filterBy="descriptionFilter"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">
        {{ props.data.codigo }} - {{ props.data.descricao }}
      </div>
    </template>
    <template slot="no-options"> Selecione um código </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">
        {{ props.data.codigo }} - {{ props.data.descricao }}
      </div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { mapActions } from 'vuex';
import { SelectWithSearch } from '@/components/Form';

export default {
  name: 'SelectCfop',
  mixins: [SearchMixin],
  components: {
    SelectWithSearch,
  },
  props: {
    value: {},
    label: {
      type: String,
      default: 'CFOP',
    },
    type: {
      type: Number,
      default: 3,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      input: null,
      cfopCollection: [],
    };
  },
  async mounted() {
    this.cfopCollection = await this.setCfopCollection({ tipo: this.type });
  },
  methods: {
    ...mapActions('fiscalComponents', ['setCfopCollection']),

    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
